import { DeliveryAsset } from './delivery-asset.model';

// TODO Update mocks with new model
export interface Delivery {
  artistName: string;
  assetGroups: AssetGroup[];
  businessLabelName?: string;
  campaignName: string;
  contactName: string;
  deliveryDate: string;
  deliveryImage: string;
  mobileDeliveryImage?: string;
  thumbnailImage?: string;
  deliveryKeyCode: string;
  deliveryType: string;
  distributionName: string;
  downloadStatus: DownloadStatus;
  offlineStatus?: DeliveryOfflineStatus;
  ecardText: string;
  emailText?: string;
  expired?: boolean;
  expiryDate: string;
  grid?: string;
  favourite: boolean;
  label?: string;
  openedDelivery: boolean;
  otpEnabled: boolean;
  popularity: number;
  reactivated?: boolean;
  releaseDate: string;
  sentBy?: string;
  share: boolean;
  track_number: number;
  upc?: string;
  waterMarked: boolean;
  deliveryHasOfflineAssets?: boolean;
  deliverySharable?: boolean;
  offlineCacheDeliverySize?: number;
}

export interface DownloadStatus {
  enableDownload?: boolean;
  cancelDownload?: boolean;
  downloading?: boolean;
  downloaded?: boolean;
  cached?: boolean;
}

export interface AssetGroup {
  assetCategoryName: string;
  numberOfAssets: number;
}

export interface OfflineDelivery extends Delivery {
  offlineAudioAssets: DeliveryAsset[];
}

export type DeliveryOfflineStatus = '' | 'readyToDownload' | 'downloading' | 'downloaded';
